import React, {useState} from 'react'
import AddUserForm from "./AddUserForm";

function AddUserButton() {
    const [isModalVisible, setIsModalVisible] = useState(false)

    const _toggleModal = (value = true) => {
        setIsModalVisible(value)
    }

    return (
        <div className="CustomerForm">
            <button className="ButtonCustom" onClick={_toggleModal}>
                <span className="material-icons">add</span>
                <span>Add new</span>
            </button>

            {isModalVisible && <AddUserForm isModalVisible={isModalVisible} toggleModal={_toggleModal}/>}
        </div>
    )
}

export default AddUserButton
